/**
 * Responsive Breakpoints
 *
 * Defines breakpoints for mobile, tablet, and desktop layouts.
 * Uses MUI's standard breakpoint system.
 */

const breakpoints = {
  values: {
    xs: 0, // Phone (portrait)
    sm: 600, // Phone (landscape) / Tablet (portrait)
    md: 960, // Tablet (landscape)
    lg: 1280, // Desktop
    xl: 1920, // Large desktop
  },
};

/**
 * Helper function to create responsive values
 * Usage: responsive({ xs: '100%', md: '50%', lg: '30%' })
 */
export const responsive = (values) => values;

/**
 * Common responsive spacing patterns
 */
export const spacing = {
  page: {
    xs: 2, // 16px on mobile
    sm: 3, // 24px on tablet
    md: 4, // 32px on desktop
    lg: 5, // 40px on large screens
  },
  section: {
    xs: 3,
    sm: 4,
    md: 6,
    lg: 8,
  },
  component: {
    xs: 1,
    sm: 2,
    md: 2,
    lg: 3,
  },
};

/**
 * Responsive width patterns
 */
export const widths = {
  contentContainer: {
    xs: '100%',
    sm: '90%',
    md: '80%',
    lg: '70%',
  },
  dialog: {
    xs: '95%',
    sm: '80%',
    md: '60%',
    lg: '50%',
  },
};

export default breakpoints;
